import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { endpoints } from "../../_config";
import { post, get } from "../../_services/apiService";
import { toast } from "react-toastify";
import Header from "../Shared/Header";
import Footer from "../Shared/Footer";



const GetQuoteStep1 = () => {

    const [uploadedImage1, setUploadedImage1] = useState(null); // State for first file upload
    const [uploadedImage2, setUploadedImage2] = useState(null); // State for second file upload
    const [isChecked, setIsChecked] = useState(false);
    const [imageId, setImageId] = useState('0');
    const handleImageUpload1 = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setUploadedImage1(imageUrl); // Set the uploaded image URL for the first input
        }

        const { name, value, type } = event.target;

        if (type === 'file') {
            // For file inputs, store the selected file
            setFormData(prevState => ({
                ...prevState,
                [name]: event.target.files[0], // Handle file uploads
            }));
        }
    };
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const handleImageUpload2 = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setUploadedImage2(imageUrl); // Set the uploaded image URL for the second input
        }


        const { name, value, type } = event.target;

        if (type === 'file') {
            // For file inputs, store the selected file
            setFormData(prevState => ({
                ...prevState,
                [name]: event.target.files[0], // Handle file uploads
            }));
        }

    };

    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 2; // Adjust this based on the number of steps
    const fieldsetsRef = useRef([]);
    const navigate = useNavigate(); // To handle navigation to /thankyou page


    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAppointmentSidebar, setShowAppointmentSidebar] = useState(false);
    const [activeTab, setActiveTab] = useState('book-appointment');
    const [serviceTypeData, setServiceTypeData] = useState();
    const [getSizeTypeData, setGetSizeType] = useState();


    const sizeData = [
        { sizeId: '14\"', sizeName: '14\"' },
        { sizeId: '17\"', sizeName: '17\"' },
        { sizeId: '21\"', sizeName: '21\"' },
        { sizeId: '24\"', sizeName: '24\"' },
    ];
    const handleNext = () => {
        if (currentStep < totalSteps) {
            animateFieldset(currentStep - 1, currentStep, true);
            setCurrentStep(currentStep + 1);
        } else if (currentStep === totalSteps) {


            onQuotation();
            // Redirect to /thankyou when at the last step
            // Trigger the redirect when the user reaches step 4


        }
    };

    const handlePrevious = () => {
        if (currentStep > 1) {
            animateFieldset(currentStep - 1, currentStep - 2, false);
            setCurrentStep(currentStep - 1);
        }

    };

    const animateFieldset = (fromIndex, toIndex, isNext) => {
        const fromFieldset = fieldsetsRef.current[fromIndex];
        const toFieldset = fieldsetsRef.current[toIndex];

        if (!fromFieldset || !toFieldset) return;

        fromFieldset.style.opacity = 0;
        setTimeout(() => {
            fromFieldset.style.display = "none";
            toFieldset.style.display = "block";
            toFieldset.style.opacity = 1;
        }, 400);
    };

    const getProgressWidth = () => {
        return `${(currentStep / totalSteps) * 100}%`;
    };

    const [formData, setFormData] = useState({
        quotationId: 0,
        firstName: '',
        lastName: '',
        emailId: '',
        contactNo: "",
        referralSource: "",
        additionalMsg: "",
        serviceId: 0,
        streetAddress: '',
        modelNumber: '',
        sizeTypeId: 0,
        productDetail: '',
        state: "",
        isActive: true,
        createdBy: 0,
        aboveGroundLevel: '',
        preferredDay1: '',
        time1: '',
        preferredDay2: '',
        time2: '',
        serialImagePath: '',
        productPath: '',
        houseStatusId: 1,
        file: '',
        fullfile: '',
        sysType: '',
        size: ''
    });

    const getServiceType = async () => {
        try {
            const response = await get(endpoints.GetServiceType)
            if (response.isSuccess === 200) {
                setServiceTypeData(response.data);
            } else {
                setError("Failed to fetch Service Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };
    const getSizeType = async () => {
        try {
            const response = await get(endpoints.GetSizeType)
            if (response.isSuccess === 200) {
                setGetSizeType(response.data);
            } else {
                setError("Failed to fetch Size Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getServiceType();
        getSizeType();
    }, []);

    const handleChange = (e) => {
        const { name, value, type } = e.target;

        if (type === 'radio') {
            // For radio buttons, simply set the selected value
            setFormData(prevState => ({
                ...prevState,
                [name]: value, // Store the selected value for the radio button group
            }));
        } else if (type === 'file') {
            // For file inputs, store the selected file
            setFormData(prevState => ({
                ...prevState,
                [name]: e.target.files[0], // Handle file uploads
            }));
        } else {
            // For other input types (text, date, etc.), update the value
            setFormData(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    };


    const onQuotation = async () => {

        if (true) {
            const formDataToSend = new FormData();

            // Append form data fields
            for (const key in formData) {
                formDataToSend.append(key, formData[key]);
            }

            try {
                const response = await post(endpoints.SaveQuatation, formDataToSend);
                if (response.isSuccess === 200) {

                    toast.success("Quotation submit successfully");
                    onReset();

                    setTimeout(() => {
                        navigate("/thank-you");
                    }, 2000);
                } else {
                    toast.error("Failed to submit form data");
                }
            } catch (error) {
                toast.error("Please try again later.");
            } finally {

            }
        } else {
            toast.warning("Please check terms & condition");

        }
    };


    const onReset = () => {
        setFormData({
            quotationId: 0,
            firstName: '',
            lastName: '',
            emailId: '',
            contactNo: "",
            referralSource: "",
            additionalMsg: "",
            serviceId: 0,
            streetAddress: '',
            modelNumber: '',
            sizeTypeId: 0,
            productDetail: '',
            state: "",
            isActive: true,
            createdBy: 0,
            aboveGroundLevel: '',
            preferredDay1: '',
            time1: '',
            preferredDay2: '',
            time2: '',
            serialImagePath: '',
            productPath: '',
            houseStatusId: 1,
            file: '',
            fullfile: '',
            sysType: '',
            size: ''
        });
    }

    const [selectedOptions, setSelectedOptions] = useState({
        crawlspace: false,
        attic: false,
        multipleSystem: false,
    });

    const handleCheckboxChange1 = (event) => {
        const { name, checked } = event.target;

        // Update the selected options state
        setSelectedOptions((prevState) => ({
            ...prevState,
            [name]: checked,
        }));

        // Update sysType with a comma-separated list
        setFormData((prevState) => {
            // Ensure sysType is initialized to an empty string if it doesn't exist
            let newSysType = prevState.sysType ? prevState.sysType.split(",") : [];

            if (true) {
                // Add the name to sysType if it isn't already present
                if (!newSysType.includes(name)) {
                    newSysType.push(name);
                }
            } else {
                // Remove the name from sysType if it's unchecked
                newSysType = newSysType.filter((item) => item !== name);
            }

            // Join the sysType list into a comma-separated string
            return {
                ...prevState,
                sysType: newSysType.join(","),
            };
        });

    };




    const [isModal1Visible, setIsModal1Visible] = useState(false);
    const [isModal2Visible, setIsModal2Visible] = useState(false);
    const [isModal3Visible, setIsModal3Visible] = useState(false);

    const handleMouseEnter3 = () => {
        setIsModal3Visible(true); // Show modal when hovered
        //  setIsModal1Visible(false);
        // setImageId(id);
        // modelToggleData('modeldatastatus', true, null)
    };

    const handle3MouseLeave = () => {
        setIsModal3Visible(false); // Hide modal when mouse leaves
        //  setIsModal2Visible(false);
        //modelToggleData('modeldatastatus', false, null)
        //setImageId(id);
    };

    // Function to handle hover event
    const handleMouseEnter2 = () => {
        setIsModal2Visible(true); // Show modal when hovered
        //  setIsModal1Visible(false);
        // setImageId(id);
        // modelToggleData('modeldatastatus', true, null)
    };

    const handleMouseEnter1 = () => {
        setIsModal1Visible(true); // Show modal when hovered
        // setIsModal2Visible(false);
        // setImageId(id);
        // modelToggleData('modeldatastatus', true, null)
    };

    const handle1MouseLeave = () => {
        setIsModal1Visible(false); // Hide modal when mouse leaves
        //  setIsModal2Visible(false);
        //modelToggleData('modeldatastatus', false, null)
        //setImageId(id);
    };
    const handle2MouseLeave = () => {
        setIsModal2Visible(false); // Hide modal when mouse leaves
        //  setIsModal2Visible(false);
        //modelToggleData('modeldatastatus', false, null)
        //setImageId(id);
    };

    const closeModal = () => {
        //   setIsModalVisible(false); // Close modal when clicking close button

        // modelToggleData('modeldatastatus', false, null)
    };




    return (
        <div>
            <Header />
            <section className="get_quote_wepper">
                <div className="card" style={{ backgroundImage: "url('images/step1.png')" }}>
                    <form id="msform" onSubmit={onQuotation} >
                        {/* Step 1 */}
                        <fieldset
                            ref={(el) => (fieldsetsRef.current[0] = el)}
                            style={{ display: currentStep === 1 ? "block" : "none" }}
                        >
                            <div className="form-card">
                                <h2 id="heading">Get a Quote...</h2>
                                <p>
                                    Please give us your information so that we will be able to send you our quote.
                                </p>
                                <div className="row mt-2 fieldset_first_weper">
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="firstName"
                                                id="firstName"
                                                className="form-control"
                                                placeholder="Full Name"
                                                required
                                                value={formData.firstName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="contactNo"
                                                id="contactNo"
                                                className="form-control"
                                                placeholder="Phone Number"
                                                value={formData.contactNo}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="emailId"
                                                id="emailId"
                                                className="form-control"
                                                placeholder="Email Address"
                                                required
                                                value={formData.emailId}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="streetAddress"
                                                id="streetAddress"
                                                className="form-control"
                                                placeholder="Address"
                                                value={formData.streetAddress}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="lastName"
                                                id="lastName"
                                                className="form-control city_inner"
                                                placeholder="City"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="state"
                                                id="state"
                                                className="form-control city_inner"
                                                placeholder="State"
                                                value={formData.state}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="zip"
                                                id="zip"
                                                className="form-control city_inner"
                                                placeholder="Zip"
                                              //  value={formData.lastName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </fieldset>


                        {/* Step 2 */}
                        <fieldset
                            ref={(el) => (fieldsetsRef.current[1] = el)}
                            style={{ display: currentStep === 2 ? "block" : "none" }}
                        >

                            <div className="row mt-1">

                                <div className="wepper_serive_select row">
                                    <div className="col-xxl-6 col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper send_quote_wepper_select">
                                            <select name="serviceId" id="serviceId" className="" value={formData.serviceId} onChange={handleChange} required >
                                                <option value="0" className="option">Air Conditioning</option>
                                                {serviceTypeData?.map((item, i) => (
                                                    <option key={item.serviceId} value={item.serviceId} className="option">{item?.serviceName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>


                                    <div className="col-xxl-6 col-xl-126 col-lg-6 col-md-6 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper send_quote_wepper_select">
                                            <select name="sizeTypeId" id="sizeTypeId" className="" value={formData.sizeTypeId} onChange={handleChange} required >
                                                <option value="0" className="option">Above Grade of house</option>
                                                {getSizeTypeData?.map((item, i) => (
                                                    <option key={item.sizeTypeId} value={item.sizeTypeId} className="option">{item?.typeName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="checkboxes__row">
                                            Select Size
                                            {sizeData?.map((item) => (
                                                <div
                                                    className={`radio_buttons__item ${formData.size == item.sizeId}`}
                                                    key={item.sizeId}
                                                >

                                                    <input
                                                        type="radio"
                                                        name="size"
                                                        value={item.sizeId}
                                                        checked={formData.size == item.sizeId}
                                                        onChange={handleChange}
                                                    />
                                                    <div className="radio__checkmark"></div>
                                                    <div className="radio__body">{item?.sizeName}</div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="additionalMsg"
                                                id="additionalMsg"
                                                className="form-control"
                                                placeholder="Other Product Information"
                                                value={formData.additionalMsg}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                        <div className="send_quote_wepper">
                                            <input
                                                type="text"
                                                name="contactNo"
                                                id="contactNo"
                                                className="form-control"
                                                placeholder="Demo"
                                                value={formData.contactNo}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                        </fieldset>

                    </form>

                    {/* Progress Bar */}
                    <div className="progress">
                        <div
                            className="progress-bar progress-bar-striped"
                            style={{ width: getProgressWidth() }}
                        ></div>
                    </div>

                    {/* Dynamic Step Display */}
                    <div className="container">
                        <div className="row setp_wepper">
                            <div className="col-lg-6 col-sm-6 col-12">
                                {/* Conditionally render "Previous Page" button */}
                                {currentStep > 1 && (
                                    <div className="previous_wepper">
                                        <span onClick={handlePrevious}>
                                            <img src="images/preview-icon.png" alt="" /> Previous Page
                                        </span>
                                        <a href="#" className="fs-title">Connect with us</a>
                                    </div>
                                )}
                            </div>
                            <div className="col-lg-6 col-sm-6 col-12 ">
                                <div className="steps">
                                    Step {currentStep} {/* Dynamic step number */}
                                    <p className="next action-button" onClick={handleNext}>
                                        {currentStep === 2 ? "Submit" : "Continue"}
                                        {currentStep !== 2 && <img src="images/right-arrow.svg" alt="" />}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isModal3Visible && (
                    <div className="model_popup2">
                        <span ><img src="images/productimage.jpeg" alt="" />
                            {/* {imageId=='1' ? 
                         */}
                            {/* <img src="images/about.png" alt="" />  : 
                        <img src="images/banner5.png" alt="" /> 
} */}
                        </span>
                    </div>
                )}

                {isModal1Visible && (
                    <div className="model_popup1">
                        <span ><img src="images/productimage.jpeg" alt="" />
                            {/* {imageId=='1' ? 
                         */}
                            {/* <img src="images/about.png" alt="" />  : 
                        <img src="images/banner5.png" alt="" /> 
} */}
                        </span>
                    </div>
                )}
                {isModal2Visible && (
                    <div className="model_popup2">
                        <span ><img src="images/serialno.jpeg" alt="" />
                            {/* {imageId=='1' ? 
                         */}
                            {/* <img src="images/about.png" alt="" />  : 
                        <img src="images/banner5.png" alt="" /> 
} */}
                        </span>
                    </div>
                )}
            </section>
            <Footer />
        </div>
    );



};



export default GetQuoteStep1;
